<template>
  <div :class="className" :id="id" style="height: 100%;width: 100%;"></div>
</template>

<script>
export default {
  name: 'pieChart',
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '200px'
    },
    height: {
      type: String,
      default: '200px'
    },
    pieLegendData: {
      type: Array
    },
    pieSeriesData: {
      type: Array
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      chart:null
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(document.getElementById(this.id));
      this.chart.setOption({
        title : {
          text:this.title,
          x:'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          x: 'left',
          data: this.pieLegendData
        },
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: [0, '70%'],
            label: {
              normal: {
                position: 'inner'
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: this.pieSeriesData
          }
        ]
      });
      let _this = this;
      window.addEventListener('resize', () => {
        _this.chart.resize();
      });
    }
  }
};
</script>
